import styled from 'styled-components'
import { Box } from 'src/components'

export const ModalBackground = styled(Box)`
    align-items: center;
    bottom: -10px;
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    justify-content: center;
    left: -10px;
    position: fixed;
    right: -10px;
    top: -10px;
    z-index: 200;
`
export const ContainerModal = styled(Box)`
    min-width: 372px;
    height: 229px;
    backdrop-filter: blur(44.4444px);
    background-color: ${({ theme }) => theme.colors.modal};
    border-radius: 1rem;
    display: flex;
    padding: 10px 20px;
    flex-direction: column;
    justify-content: flex-start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        min-width: 469px;
        height: 284px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 367px;
        height: 257px;
    }
`
